import React, { useState, useCallback, useEffect } from 'react';
import UploadTemplate from './UploadTemplate/UploadTemplate.container';
import UploadTerms from './UploadTerms/UploadTerms.container';
import Menu from './Menu';
import useGrouping from 'Common/Utils/Hooks/useGrouping';

const initialState = { activeMenu: '' };


const UploadFilesContainer = (
    year,
    updateYear
) => {

    document.title = "Contract Management - Upload Files";    
    const showUploadTemplate = !!year;

    const handleYearUpdate = useCallback(value => {
        if (value > 0) {
            updateYear(value);
        } else {
            updateYear('');
        }
        clearTeamsAndTypes();
        // eslint-disable-next-line
    }, []);

	const [{ activeMenu }, setActive] = useState(initialState);
    const grouping = useGrouping();

    useEffect(() => {
        setActive(initialState);
    }, [grouping]);

	const handleMenuChange = useCallback((menuToOpen) => {
        setActive({ activeMenu: menuToOpen });
	}, []);

	switch (activeMenu) {
		case 'upload_template':
            return (
                    <UploadTemplate onClose={handleMenuChange} />

			);
		case 'upload_terms':
			return (
				<UploadTerms onClose={handleMenuChange} />
			);
		default:
			return (
				<Menu onChange={handleMenuChange} />
			);
	}
};

export default UploadFilesContainer;
